$('.owl-carousel.timeline-slides').owlCarousel({
	items: 4,
	nav: true,
	smartSpeed: 300,
	margin: 30,
	slideBy: 'page',
	loop: false,
	navRewind: false,
	navText: ['<i class="fa-solid fa-circle-arrow-left"></i>', '<i class="fa-solid fa-circle-arrow-right"></i>'],
	responsive: {
		0: {
			items: 1,
		},
		700: {
			items: 2,
		},

		1000: {
			items: 3,
		},
		1400: {
			items: 4,
		},
	},
});

const cards = document.querySelectorAll('.content-card');
let maxHeight = 0;
let maxWidth = 0;

cards.forEach((card) => {
	const cardHeight = card.offsetHeight;
	const cardWidth = card.offsetWidth;
	if (cardHeight > maxHeight) {
		maxHeight = cardHeight;
	}
	if (cardWidth > maxWidth) {
		maxWidth = cardWidth;
	}
});

cards.forEach((card) => {
	card.style.height = maxHeight + 'px';
	// card.style.width = maxWidth + 'px';
});
$(window).on('resize', function () {
	cards.forEach((card) => {
		card.style.height = maxHeight + 'px';
		// card.style.width = maxWidth + 'px';
	});
});
